// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IChatsGetArchivedChatsDesktopRequest,
  TChatsGetArchivedChatsDesktopModel,
  IMappers,
  TChatsGetArchivedChatsDesktopResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IChatListResponseSchema } from '../../../entities/chat/ChatListResponseSchema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createChatsGetArchivedChatsDesktopModel(
  parameters: IChatsGetArchivedChatsDesktopRequest,
): TChatsGetArchivedChatsDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'chats',
    pathApi: '/v1/chats/get-archived-chats-desktop/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IChatsGetArchivedChatsDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IChatsGetArchivedChatsDesktopRequest;
}

export async function fetchChatsGetArchivedChatsDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsGetArchivedChatsDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChatsGetArchivedChatsDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChatsGetArchivedChatsDesktopModel(parameters),
    config,
  )) as FetchResponse<TChatsGetArchivedChatsDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatListResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChatsGetArchivedChatsDesktopResponse>;
}
